import { Navigate, useLocation } from "react-router-dom";

/** The config page moved into the customer chat page; old links keep their query (`?tenant=`). */
export default function CustomerChatConfigRedirect() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: "/agent/customer-chat", search }} replace />;
}
